export default "__VITE_ASSET__dbcc1cb1__"